import React from 'react';

import AssistantMessage from './assistant_message';
import UserMessage from './user_message';

import type { ActionVerdict, AssistantAction, Message } from './types';

interface Props {
  message: Message;
  resolveDisabled: boolean;
  showAdminDetails: boolean;
  showStopSpeaking: boolean;
  onResolveAction: (action: AssistantAction, verdict: ActionVerdict) => void;
  onStopSpeaking: () => void;
}

export default function MessageItem({
  message,
  resolveDisabled,
  showAdminDetails,
  showStopSpeaking,
  onResolveAction,
  onStopSpeaking,
}: Props) {
  if (message.role === 'user') {
    return <UserMessage message={message} />;
  }

  return (
    <AssistantMessage
      message={message}
      resolveDisabled={resolveDisabled}
      showAdminDetails={showAdminDetails}
      showStopSpeaking={showStopSpeaking}
      onResolveAction={onResolveAction}
      onStopSpeaking={onStopSpeaking}
    />
  );
}
